<template>
  <div class="filter-check-list">
    <template v-for="(item, index) in payload">
      <ul v-if="!index.includes('price')" :key="index" :class="index">
        <li v-for="subitem in item" :key="index + subitem">
          <span @click="delete_val(subitem, index)">x</span>
          <span>{{ get_name(subitem, index) }}</span>
        </li>
      </ul>
      <ul v-else-if="fake_payload[index]" :key="index">
        <li v-for="subitem in item" :key="index + subitem">
          <span @click="delete_val(subitem, index)">x</span>
          <span>{{ subitem }}</span>
        </li>
      </ul>
    </template>
  </div>
</template>
<script>
export default {
  props: ["payload", "fake_payload"],
  data() {
    return {};
  },
  methods: {
    delete_val(subitem, index) {
      let payload = { ...this.payload };
      payload[index].some((item, sub) => {
        if (item == subitem) {
          payload[index].splice(sub, 1);
        }
      });
      this.bus.$emit("changeFilter", payload);
    },
    get_name(subitem, index) {
      let name = subitem;
      this.fake_payload[index].some((item) => {
        if (item.id - 0 == subitem - 0) {
          name = item.name || item.attribute_value;
          return name;
        }
      });
      return name;
    },
  },
};
</script>
<style scoped lang='scss'>
.filter-check-list {
  & > ul {
    display: flex;
    flex-wrap: wrap;
    padding: 0;
    margin: 0;
    li {
      list-style: none;
      width: auto;
      margin-right: 8px;
      padding: 6px;
      background-color: #f1f3f2;
      color: black;
      margin-bottom: 7px;
      border-radius: 3px;
      span {
        font-size: 13px;
        &:nth-child(1) {
          cursor: pointer;
          padding: 5px 3px 5px 5px;
          color: #595e82;
        }
        &:nth-child(2) {
          color: black;
        }
      }
    }
  }
}
</style>